/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';

class BookmarkFormContent extends Component {
  constructor(props) {
    super(props);
    const bookmark = this.props.bookmark;
    this.state = {
      reason: (bookmark && bookmark.get('reason')) || 'revisit',
      comment: (bookmark && bookmark.get('comment')) || '',
    };
  }

  handleRemove(e) {
    // stop form submitting
    e.preventDefault();
    this.props.onRemove();
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.onSave) {
      this.props.onSave(this.state);
    }
  }

  renderRemove() {
    return (
      <h3 className="bookmark-popup-heading remove">
        <button
          className="remove-bookmark"
          onClick={this.handleRemove.bind(this)}
        >
          Remove this bookmark
        </button>
      </h3>
    );
  }

  renderSave() {
    return <h3 className="bookmark-popup-heading add">Bookmark this video</h3>;
  }

  render() {
    return (
      <form
        ref="form"
        onSubmit={this.handleSubmit.bind(this)}
        className="bookmark-form"
      >
        {this.props.bookmark ? this.renderRemove() : this.renderSave()}
        <FormGroup controlId="reason">
          <FormControl
            componentClass="select"
            defaultValue={this.state.reason}
            onChange={(e) => {
              this.setState({ reason: e.target.value });
            }}
          >
            <option value="revisit">I want to watch again.</option>
            <option value="problem">I&apos;m having trouble</option>
          </FormControl>
        </FormGroup>
        <FormGroup controlId="comment">
          <FormControl
            componentClass="textarea"
            placeholder="Comment (Optional)"
            rows="3"
            value={this.state.comment}
            onChange={(e) => this.setState({ comment: e.target.value })}
          />
        </FormGroup>
        <button
          type="submit"
          className="save-bookmark btn btn-primary"
          name="action"
        >
          Save
        </button>
        <button
          onClick={this.props.onCancel}
          className="hide-bookmark btn-link"
          type="button"
          name="cancel"
        >
          Cancel
        </button>
      </form>
    );
  }
}

export default BookmarkFormContent;
